import React from "react";
import { FieldValues } from "react-hook-form";

import FingridTestGenericInitialForm from "../shared/FingridTestGenericInitialForm";
import TestFcrDPlanningsForm from "./TestFcrDPlanningsForm";
import { TestTypeEnum } from "../shared/types";

const TestFingridFcrD: React.FC = () => {
  const [initialData, setInitialData] = React.useState<FieldValues | null>(null);

  const handleInitialSubmit = (data: FieldValues) => {
    setInitialData(data);
  };

  return !initialData ? (
    <FingridTestGenericInitialForm onSubmit={handleInitialSubmit} testType={TestTypeEnum.fcrD} />
  ) : (
    <TestFcrDPlanningsForm initialData={initialData} />
  );
};

export default TestFingridFcrD;
